import StreetParkingPlates from 'feature/street-parking/street-parking-plates/street-parking-plates';

export default StreetParkingPlates;
